
  module.exports =
  {

    add:
    {

      _init: function ()
      {

        this.onClickIssueDate()

        this.onChangeReason()

      },

      onClickIssueDate: function()
      {

        $('#issue_date-calendar').not('.js-ignore').click(function ()
        {
  
          var form = $(this).closest('form').serialize()
  
          APPLICATION._datepicker = function (date)
          {
  
            form += '&issue_date=' + date
  
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'cash-payment/add?' + form, 'CashPayment', 'add')
  
          }
  
          var parts = $('#issue_date').val().split('/')
  
          $('#calendar').data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0]).trigger('click')
  
        }
        ).addClass('js-ignore')

      },

      onChangeReason: function ()
      {

        $('#reason').not('.js-ignore').change(function ()
        {

          if ('Other' === $(this).val())
          {
            $('#reason-other-wrapper').show()
          }

          else
          {
            $('#reason-other-wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    },

    toIssue:
    {

      _init: function ()
      {

        this.onChangeValue()

        this.onGenerateBatch()

      },

      onChangeValue: function()
      {

        $('#value').not('.js-ignore').change(function ()
        {

          if ('' === $(this).val())
          {
            $('#generate-batch').prop('disabled', true)
          }

          else
          {
            $('#generate-batch').prop('disabled', false)
          }

        }
        ).addClass('js-ignore').trigger('change')

      },

      onGenerateBatch: function ()
      {

        $('#generate-batch').not('.js-ignore').click(function ()
        {
          $('#confirm-batch').addClass('hidden')
        }
        ).addClass('js-ignore')

      }

    },

    toIssueList:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#signups', 'CashPayment', 'toIssueList')

        this.onExport()

      },

      onExport: function ()
      {

        $('#export-batch').not('.js-ignore').click(function ()
        {
          $('#confirm-batch').removeClass('hidden')
        }
        ).addClass('js-ignore')

      }

    },

    issued:
    {

      _init: function ()
      {
   
        if (0 !== $('.js-searched').length)
        {
          APPLICATION._APPLICATION.load($('#signups'), APPLICATION._PATH_PREFIX + 'cash-payment/issued-list', 'CashPayment', 'issuedList') 
        }

      }

    },

    issuedList:
    {

      _cashPayments: [],

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#signups', 'CashPayment', 'issuedList')

        this.onSelect()

        this.onCancel()

        this.onDelete()

      },

      onSelect: function ()
      {

        $('.js-cash_payment').not('.js-ignore').change(function ()
        {

          var id = $(this).data('id')

          var index = APPLICATION.CashPayment.issuedList._cashPayments.indexOf(id)

          if (-1 === index)
          {
            APPLICATION.CashPayment.issuedList._cashPayments.push(id)
          }

          else
          {
            APPLICATION.CashPayment.issuedList._cashPayments.splice(index, 1)
          }

        }).addClass('js-ignore')

      },

      onCancel: function ()
      {

        $('#cancel').not('.js-ignore').click(function ()
        {

          var ids = APPLICATION.CashPayment.issuedList._cashPayments.join(',')

          var url = APPLICATION._PATH_PREFIX + 'cash-payment/cancel-issued?ids=' + ids

          APPLICATION._APPLICATION.customModal(url, 'CashPayment', 'cancelIssued')

        }
        ).addClass('js-ignore')

      },

      onDelete: function ()
      {

        $('#delete').not('.js-ignore').click(function ()
        {

          var ids = APPLICATION.CashPayment.issuedList._cashPayments.join(',')

          var url = APPLICATION._PATH_PREFIX + 'cash-payment/delete-issued?ids=' + ids

          APPLICATION._APPLICATION.customModal(url, 'CashPayment', 'deleteIssued')

        }
        ).addClass('js-ignore')

      }

    },

    confirm:
    {

      _init: function ()
      {

        $('.js-status').not('.js-ignore').change(function ()
        {

          if ('2' === $('.js-status:checked').val())
          {
            $('#cheque-numbers').show()
          }

          else
          {
            $('#cheque-numbers').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      }

    }

  }